<script>
  import { selectedCountry, SUPPORTED_COUNTRIES } from '../countryStore';
</script>

<div class="country-selector">
  <select bind:value={$selectedCountry} aria-label="Select Country">
    {#each SUPPORTED_COUNTRIES as country}
      <option value={country.code}>
        {country.flag} {country.code}
      </option>
    {/each}
  </select>
</div>

<style>
  .country-selector select {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 0.4rem;
    font-size: 0.9rem;
    cursor: pointer;
    color: #333;
    font-weight: 500;
  }
  
  .country-selector select:focus {
    outline: none;
    border-color: #007bff;
  }
</style>